module.exports = __webpack_public_path__ + "static/media/Montana2925.ff18b5b9.jpg";